"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var md5_1 = __importDefault(require("crypto-js/md5"));
var enc_base64_1 = __importDefault(require("crypto-js/enc-base64"));
var utils_1 = require("./utils");
var const_1 = require("./const");
var K18nUtils = /** @class */ (function () {
    function K18nUtils(options) {
        this.normalizeText = function (item) {
            var _a = item.text, text = _a === void 0 ? '' : _a, _b = item.desc, desc = _b === void 0 ? '' : _b;
            return "<<text:>>" + text + "<<desc:>>" + desc;
        };
        this.locale = options.locale || utils_1.getDefaultLocale();
        this.fallbackLocale = options.fallbackLocale || const_1.DEFAULT_FALLBACL_LOCALE;
        this.messages = this.processMessages(options.messages);
    }
    K18nUtils.prototype.processMessages = function (messages) {
        var _a = messages || {}, _b = _a.language, language = _b === void 0 ? [] : _b, _c = _a.textList, textList = _c === void 0 ? [] : _c;
        return language.reduce(function (pkg, lang, index) {
            var textOfLang = {};
            textList.forEach(function (item) {
                var _a = item.key, key = _a === void 0 ? '' : _a, _b = item.hash, hash = _b === void 0 ? '' : _b, text = item.text;
                textOfLang[key] = text[index];
                textOfLang[hash] = text[index];
            });
            pkg[lang] = __assign({}, textOfLang);
            return pkg;
        }, {});
    };
    K18nUtils.prototype.changeLocale = function (locale) {
        this.locale = locale;
    };
    K18nUtils.prototype.changeFallbackLocale = function (locale) {
        this.fallbackLocale = locale;
    };
    K18nUtils.prototype.getText = function (textParams) {
        var _a = textParams.id, id = _a === void 0 ? '' : _a, _b = textParams.text, text = _b === void 0 ? '' : _b, _c = textParams.desc, desc = _c === void 0 ? '' : _c, params = textParams.params;
        if (id) {
            return this.getTextByKeyOrText(id, params);
        }
        else {
            return this.getTextByKeyOrText({ text: text, desc: desc }, params);
        }
    };
    K18nUtils.prototype.getTextByKeyOrText = function (key, params) {
        var prop = '';
        if (typeof key === 'string') {
            prop = key;
        }
        else {
            var normalized = this.normalizeText({ text: key.text, desc: key.desc });
            var hash = md5_1.default(normalized).toString(enc_base64_1.default);
            prop = hash;
        }
        var originText = this.messages[this.locale] && this.messages[this.locale][prop];
        if (!originText) {
            // 再查 fallback 的 locale
            originText = this.messages[this.fallbackLocale] && this.messages[this.fallbackLocale][prop];
        }
        if (!originText) {
            if (typeof key === 'string') {
                console.warn("\u65E0\u6CD5\u901A\u8FC7 key: " + key + " \u627E\u5230\u6587\u6848");
                return key;
            }
            else {
                console.warn("\u65E0\u6CD5\u901A\u8FC7\u4E2D\u6587\uFF1A" + key.text + " \u548C\u573A\u666F " + key.desc + " \u627E\u5230\u6587\u6848");
                return key.text || '';
            }
        }
        else if (!params) {
            return originText;
        }
        else {
            Object.keys(params).forEach(function (prop) {
                originText = originText
                    .replace("${" + prop + "}", "" + params[prop])
                    .replace("{" + prop + "}$", "" + params[prop])
                    .replace("{" + prop + "}", "" + params[prop]);
            });
            return originText;
        }
    };
    return K18nUtils;
}());
exports.default = K18nUtils;
